namespace GeniuzPOS.Inventory {
    export class IcStockSoldDtColumns {
        static columnsKey = 'Inventory.IcStockSoldDt';
    }
}
